export const VERSION = '4.0.1'
let quality = '';
let mute = false;
let first = true;
let home = true;
let log = 0;
let logs = '';
let offset = 0;
let showLogo = false;

// functions to generate random device Id
export function getDeviceName() {
  const deviceId = getId();
  return deviceId;
}

function getId() {
  const deviceId = get('device-id');
  if (deviceId) {
    return deviceId.toUpperCase();
  }
  let uid = getUID();
  uid = uid.toUpperCase();
  set('device-id', uid);
  return uid;
}

function get(key) {
  return localStorage[`bd-android-app__${key}`];
}

function set(key, val) {
  localStorage[`bd-android-app__${key}`] = val;
}

function getUID() {
  return "LGOS" + genRandStr(9);
}

function genRandStr(length = 41) {
  // Math.random returns number with length between 16 and 18 chars
  // if length below 16 do in one go
  if (length <= 16) {
    return Math.random().toString(36).substring(2, length + 2);
  }

  // else calculate how many iterations we need
  const iterations = Math.ceil(length / 16);
  let outputStr = '';

  for (let i = 0; i < iterations; i += 1) {
    outputStr += Math.random().toString(36).substring(2, 18);
  }

  // correct length if it's too high
  if (outputStr.length > length) {
    outputStr = outputStr.substring(0, length);
  }

  return outputStr;
}

// function for fireAnalytics
export function fireAnalytics(category, action, label) {
  ga('send', {
    hitType: 'event',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    hitCallback: function () {
    }
  });
}

export function setQualityFlag(_quality) {
  quality = _quality;
}

export function getQualityFlag() {
  return quality;
}

export function setMuteFlag(_mute) {
  mute = _mute;
}

export function getMuteFlag() {
  return mute;
}

export function setLogoFlag(_showLogo) {
  showLogo = _showLogo;
}

export function getLogoFlag() {
  return showLogo;
}

export function setLogsFlag(_logs) {
  logs = _logs;
}

export function getLogsFlag() {
  return logs;
}
// check if app opened first time
export function setFirstTime(first1) {
  first = first1;
}

export function getFirstTime() {
  return first;
}

// check if home screen is the first screen
export function setIsHomeFirstScreen(home1) {
  home = home1;
}

export function getIsHomeFirstScreen() {
  return home;
}

// check if login is for first time
export function setFirst(log1) {
  log = log1;
}

export function getFirst() {
  return log;
}

// check if login is for first time
export function storeOffset(offset1) {
  offset = offset1;
}

export function getOffset() {
  return offset;
}
